<template>
  <section class="logo-wall flex flex-col justify-around h-full w-full mo:pt-24">
    <div class="logo-wall__logos mt-auto px-12 w-full mx-auto max-w-6xl flex flex-col md:flex-row items-center md:justify-between" @mouseenter="linksActive = false">
      <img
        src="@/assets/svg/ccurl_gallery_logo.svg"
        class="logo-wall__logo"
        @click="gotoSection(contentIDs.GALLERY)" />
      <img
        src="@/assets/svg/ccurl_consulting_logo.svg"
        class="logo-wall__logo my-24 md:my-0"
        @click="gotoSection(contentIDs.CONSULTING)" />
      <img
        src="@/assets/svg/ccurl_gtn_logo.svg"
        class="logo-wall__logo mb-24 md:mb-0"
        @click="gotoSection(contentIDs.GTN)" />
      <img
        src="@/assets/svg/ccurl_conversation_logo.svg"
        class="logo-wall__logo"
        @click="gotoSection(contentIDs.CONVERSATION)" />
    </div>
    <div class="mo:pt-32 w-full text-brand mt-auto text-center">
      <template v-if="c.members.length > 1">
        <button class="u-p--small" @click="gotoSection(contentIDs.STAUDINGER)">Dirk Staudinger</button>
        <div class="dash">&mdash;</div>
        <button class="u-p--small" @click="gotoSection(contentIDs.LANZENAUER)">Johann Haehling von Lanzenauer</button>
      </template>
      <template v-else>
        <button class="u-p--small" @click="gotoSection(contentIDs.STAUDINGER)">Dirk Staudinger</button>
      </template>
    </div>
  </section>
</template>

<script>
import content from '../mixins/content'
import { CONTENT_IDS } from '@/util/enums'

export default {
  data() {
    return {
      isActive: false,
      linksActive: false,
      activeLogoIndex: null,
      contentIDs: CONTENT_IDS
    }
  },
  mixins: [content],
  methods:{
    gotoSection(id) {
      this.$store.commit('setActiveContentId', id)
      this.$emit('section-selected', id)
    },
  },
}
</script>

<style lang="stylus">
.dash
  line-height 0.7
.logo-wall
  &__logos img
    height auto
    width 135px
  &__logo
    cursor pointer
    opacity 1

</style>
